import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
  } from '@chakra-ui/react'
import { useRef } from "react";
import ActionButton from "./ActionButton";

type Props = {
  onClick: () => void;
  isOpen: any;
  onOpen: () => void
  onClose: () => void
  title: string;
  desc: string;
  color?: string;
}

export default function SModal(props:Props) {
    const cancelRef = useRef(null);

  return (
    <>
    
      <AlertDialog
        isOpen={props.isOpen}
        leastDestructiveRef={cancelRef}
        onClose={props.onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              {props.title}
            </AlertDialogHeader>

            <AlertDialogBody>
              {props.desc}
            </AlertDialogBody>

            <AlertDialogFooter>
              <ActionButton
                marginRight='12px'
                ref={cancelRef}
                onClick={props.onClose} 
                backgroundColor='button.grey'
                _hover={{bg: "brand.grey", color:'black'}} 
                color='black'
                text='취소' 
              />
              <ActionButton
                onClick={() => { props.onClick(); props.onClose(); }} 
                backgroundColor={props.color ? `button.${props.color}` : 'button.red'} 
                _hover={{bg: props.color ? `hover.${props.color}` : "hover.red", color:'white'}} 
                text='확인' 
              />
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  )
}
